import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { resetWebauthnFlow } from "../../redux/actions/auth";
import { isPreauthExpired } from "./components/ui";

/**
 * Returns a handler that, when a webauthn call fails with PREAUTH_EXPIRED,
 * shows a "session expired" toast and resets the pre-auth flow — which drops
 * the user back to the login (password) screen so they can restart. Returns
 * true if it handled the error, false otherwise (so callers can fall through
 * to their normal error handling).
 */
export function usePreauthExpiryGuard() {
  const dispatch = useDispatch();
  return (error) => {
    if (!isPreauthExpired(error)) return false;
    toast.error("Your session expired. Please sign in again.");
    dispatch(resetWebauthnFlow());
    return true;
  };
}
